import { Link } from "react-router-dom";
function NotFound() {
  return (
    <>
      <main className="flex min-h-full w-screen h-screen flex-1 flex-col justify-center px-6 py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold text-blue-500">404</p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Page not found
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            Sorry, we couldn’t find the page you’re looking for.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              to="/login"
              className="rounded-md bg-blue-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
            >
              Go back home
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}

export default NotFound;
